import { atom, selectorFamily } from 'recoil';

import { LineDictionaryModel, LineModel } from '@/lib/models/lines/types';
import { getLineDetails } from '@/lib/models/lines/utils/get-line-details';

export const linesState = atom<LineDictionaryModel>({
  key: 'linesState',
  default: {},
});

export const getLinesByIds = selectorFamily<LineModel[], string[]>({
  key: 'getLinesByIds',
  get:
    (lineIds) =>
    ({ get }) => {
      const lineDictionary = get(linesState);

      return getLineDetails({ lineIds, lines: lineDictionary });
    },
});
